

import React from "react";
import { KpiIcon } from "./KpiIcons";

const KpiPageHeader = ({
  selectedFY,
  totalCount = 0,
  completedCount = 0,
  pendingCount = 0,
  selectedLocation = null,
  onClearLocation,
  onOpenFilters,
  advFilterCount = 0,
}) => {
  return (
    <div
      style={{
        background: "var(--surface)",
        borderBottom: "1px solid var(--rule)",
        padding: "20px 28px 16px",
        flexShrink: 0,
      }}
    >
      {/* ── Title row ── */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
        }}
      >
        {/* Left: title + meta */}
        <div>
          <h1
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "var(--ink)",
              margin: 0,
              letterSpacing: "-0.03em",
              lineHeight: 1.2,
              fontFamily: "var(--font-sans)",
            }}
          >
            Quantitative KPIs
          </h1>

        
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 8,
              flexWrap: "wrap",
            }}
          >
            {selectedFY && (
              <span
                style={{
                  fontSize: 11.5,
                  fontFamily: "var(--font-mono)",
                  color: "var(--ink-4)",
                  background: "var(--surface-3)",
                  padding: "2px 10px",
                  borderRadius: 20,
                }}
              >
                {selectedFY.name}
              </span>
            )}

            {/* Separator */}
            {selectedFY && (
              <span style={{ width: 3, height: 3, borderRadius: "50%", background: "var(--rule-2)", flexShrink: 0 }} />
            )}

            <span
              style={{
                fontSize: 12,
                fontFamily: "var(--font-mono)",
                color: "var(--ink-4)",
              }}
            >
              {totalCount} items
            </span>

            {/* <Stat label="Done"    value={completedCount} color="var(--green)" />
            <Stat label="Pending" value={pendingCount}   color="var(--amber)" /> */}

            {/* Selected location badge */}
            {selectedLocation && (
              <span className="kpi-location-badge">
                <KpiIcon name="location" size={12} color="var(--accent)" />
                {selectedLocation.name}
                <button
                  onClick={onClearLocation}
                  style={{
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: 16,
                    lineHeight: 1,
                    color: "var(--ink-4)",
                    padding: 0,
                    marginLeft: 2,
                  }}
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>

        {/* Right: Advanced Filters button */}
        {/* <button
          onClick={onOpenFilters}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 16px",
            border: `1.5px solid ${advFilterCount > 0 ? "var(--accent)" : "var(--rule)"}`,
            borderRadius: 8,
            background: advFilterCount > 0 ? "var(--accent-3)" : "var(--surface)",
            color: advFilterCount > 0 ? "var(--accent)" : "var(--ink-2)",
            fontWeight: 700,
            fontSize: 13,
            fontFamily: "var(--font-sans)",
            cursor: "pointer",
            transition: "all 0.15s",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          <KpiIcon name="filter" size={14} />
          Filters
          {advFilterCount > 0 && (
            <span
              style={{
                background: "var(--accent)",
                color: "#fff",
                fontSize: 10,
                fontWeight: 700,
                padding: "1px 6px",
                borderRadius: 20,
              }}
            >
              {advFilterCount}
            </span>
          )}
        </button> */}
      </div>
    </div>
  );
};

/* Mini stat pill */
const Stat = ({ label, value, color }) => (
  <>
    <span style={{ width: 3, height: 3, borderRadius: "50%", background: "var(--rule-2)", flexShrink: 0 }} />
    <span style={{ fontSize: 12, fontFamily: "var(--font-mono)", color }}>
      {value} {label}
    </span>
  </>
);

export default KpiPageHeader;